// opervex-frontend/src/routes/materialManagementRoutes.js

import Product from "../pages/MaterialManagement/Product";
import Category from "../pages/MaterialManagement/Category";
import StorageLocation from "../pages/MaterialManagement/StorageLocation";
import GoodsMovement from "../pages/MaterialManagement/GoodsMovement";
import UnitsMeasure from "../pages/MaterialManagement/UnitsMeasure";

const registerRoutes = [
  // Product
  { path: "MaterialManagement/Product", private: true, component: <Product />, role: "PRODUCTS" },
  { path: "MaterialManagement/Product/:id", private: true, component: <Product />, role: "PRODUCTS" },

  // Category
  { path: "MaterialManagement/Category", private: true, component: <Category />, role: "CATEGORIES" },
  { path: "MaterialManagement/Category/:id", private: true, component: <Category />, role: "CATEGORIES" },

  // Storage Location
  { path: "MaterialManagement/StorageLocation", private: true, component: <StorageLocation />, role: "STORAGE_LOCATION" },
  { path: "MaterialManagement/StorageLocation/:id", private: true, component: <StorageLocation />, role: "STORAGE_LOCATION" },

  // Goods Movement
  { path: "MaterialManagement/GoodsMovement", private: true, component: <GoodsMovement />, role: "GOODS_MOVEMENT" },
  { path: "MaterialManagement/GoodsMovement/:id", private: true, component: <GoodsMovement />, role: "GOODS_MOVEMENT" },

  // Units Measure
  { path: "MaterialManagement/UnitsMeasure", private: true, component: <UnitsMeasure />, role: "UNIT_MEASUREMENT" },
];

export default registerRoutes;
